var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.385 12.2386C13.8818 13.2296 13.0596 14.0223 12.0508 14.4887C11.042 14.9551 9.90545 15.0681 8.82457 14.8094C7.74368 14.5508 6.78144 13.9355 6.09305 13.063C5.40467 12.1904 5.03028 11.1114 5.03028 10C5.03028 8.88861 5.40467 7.80961 6.09305 6.93706C6.78144 6.06451 7.74368 5.44928 8.82457 5.19063C9.90545 4.93197 11.042 5.04496 12.0508 5.51137C13.0596 5.97778 13.8818 6.77042 14.385 7.76143H19.7382C19.1881 5.36668 17.7756 3.25826 15.7703 1.83846C13.7649 0.418667 11.307 -0.213112 8.86548 0.0636722C6.42401 0.340457 4.1699 1.50643 2.53324 3.33911C0.896577 5.1718 -0.00805664 7.54291 -0.00805664 10C-0.00805664 12.4571 0.896577 14.8282 2.53324 16.6609C4.1699 18.4936 6.42401 19.6596 8.86548 19.9364C11.307 20.2131 13.7649 19.5814 15.7703 18.1616C17.7756 16.7418 19.1881 14.6334 19.7382 12.2386H14.385Z",
    fill: "#F8485E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0925 12.2386C25.5956 13.2296 26.4178 14.0223 27.4266 14.4887C28.4354 14.9551 29.572 15.0681 30.6528 14.8094C31.7337 14.5508 32.696 13.9355 33.3844 13.063C34.0727 12.1904 34.4471 11.1114 34.4471 10C34.4471 8.88861 34.0727 7.80961 33.3844 6.93706C32.696 6.06451 31.7337 5.44928 30.6528 5.19063C29.572 4.93197 28.4354 5.04496 27.4266 5.51137C26.4178 5.97778 25.5956 6.77042 25.0925 7.76143H19.7393C20.2893 5.36668 21.7018 3.25826 23.7072 1.83846C25.7125 0.418667 28.1705 -0.213112 30.6119 0.0636722C33.0534 0.340457 35.3075 1.50643 36.9442 3.33911C38.5808 5.1718 39.4855 7.54291 39.4855 10C39.4855 12.4571 38.5808 14.8282 36.9442 16.6609C35.3075 18.4936 33.0534 19.6596 30.6119 19.9364C28.1705 20.2131 25.7125 19.5814 23.7072 18.1616C21.7018 16.7418 20.2893 14.6334 19.7393 12.2386H25.0925Z",
    fill: "#F8485E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.4789,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBicycle);
export default __webpack_public_path__ + "97131/static/media/logo-bicycle.0ae3bf6b686ab7004480dd68a012104d.svg";
export { ForwardRef as ReactComponent };